module.exports = {"510981001":"太和街道","510981002":"平安街道","510981100":"武安镇","510981101":"大榆镇","510981102":"广兴镇","510981103":"金华镇","510981104":"沱牌镇","510981105":"太乙镇","510981106":"金家镇","510981107":"复兴镇","510981108":"天仙镇","510981109":"仁和镇","510981110":"青岗镇","510981111":"洋溪镇","510981112":"香山镇","510981113":"明星镇","510981114":"涪西镇","510981117":"潼射镇","510981118":"曹碑镇","510981119":"官升镇","510981120":"文升镇","510981121":"东岳镇","510981122":"瞿河镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510981.json
// module id = 2452
// module chunks = 0